import { ClientViewProvider } from "./ClientViewProvider";
import { ClientViewGeolocationProvider } from "./ClientViewGeolocationProvider";
import { ClientViewRouteLocaleProvider } from "./ClientViewRouteLocaleContext";
import ClientViewIntlBridge from "./ClientViewIntlBridge";
import { PublicAccountProvider } from "./PublicAccountProvider";

/**
 * Standard client-view provider stack for runtime and public AutoMapa routes.
 */
export function ClientViewRuntimeProviders({ slug, previewToken = null, children }) {
  return (
    <ClientViewProvider slug={slug} previewToken={previewToken}>
      <ClientViewGeolocationProvider>
        <ClientViewRouteLocaleProvider>
          <ClientViewIntlBridge>
            <PublicAccountProvider>{children}</PublicAccountProvider>
          </ClientViewIntlBridge>
        </ClientViewRouteLocaleProvider>
      </ClientViewGeolocationProvider>
    </ClientViewProvider>
  );
}

export default ClientViewRuntimeProviders;
